// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ktzl","clinicsSelect":"styles_clinicsSelect__4O0QL"};